<template>
  <div class="container input">
    <p :class="{'active' : active, 'uk-form-danger': error && submitted && !hover}"
       :data-text="placeholder"
       @keydown="limit"
       @blur="submit"
       @hover="setHover(true)"
       @input="onInput"
       @keydown.delete="deleteText"
       @keydown.esc="setActive(false)"
       class="description-input"
       contenteditable="true"
       @paste="onPaste"
       id="input"
       ref="input"></p>
    <div :class="{'limit-container': characterLimitCheck}" v-if="characterLimitCheck">
      <p class="inner">{{overLimit}}
        <span v-if="overLimit < 2">{{$t('uploadDetailsInput.characterLimitPlaceholder')}}</span>
        <span v-else>{{$t('uploadDetailsInput.characterLimitPlaceholderPlural')}}</span>
      </p>
    </div>
    <input-validation-message
      :error="error"
      :message="message"
      :submitted="submitted"
      v-if="!characterLimitCheck">
    </input-validation-message>
  </div>
</template>

<script>
  import inputValidationMessage from '../../ui-components/validation/input-validation-message'
  import urlReplace from '../../../utils/url-helpers'
  import contentEditableUtil from '../../../utils/content-editable-util'
  import * as misc from '../../../enums/misc'

  export default {
    name: 'description-input',
    props: ['value', 'placeholder', 'error', 'message', 'submitted'],
    components: {
      inputValidationMessage
    },
    data() {
      return {
        active: false,
        hover: false,
        inputText: '',
        characterLimit: 1024,
        characterLimitCheck: false,
        overLimit: 0
      }
    },
    methods: {
      limit(el) {
        if (this.characterLimitCheck === false) {
          this.overLimit = 0
        }
      },
      onInput(el) {
        this.$emit('resetError')
        if (el.target.innerText.length > this.characterLimit) {
          this.characterLimitCheck = true
        } else {
          this.characterLimitCheck = false
        }
        if (this.inputText !== this.value) {
          if (!this.active) {
            this.active = true
          }
        }
        if (el.target.innerText.length > this.characterLimit) {
          this.overLimit = el.target.innerText.length - this.characterLimit
        }
        this.inputText = el.target.innerText
      },
      setHover(value) {
        this.hover = value
      },
      setActive(isActive) {
        this.active = isActive
        if (this.active) {
          this.$refs.input.focus()
        }
      },
      onPaste(el) {
        window.setTimeout(() => {
          this.submit()
        }, 1000)
      },
      deleteText(el) {
        this.setActive(false)
        if (el.keyCode === 8) {
          if (this.overLimit > 0) {
            this.overLimit = el.target.innerText.length - this.characterLimit
          }
        }
        if (el.target.innerText.length <= this.characterLimit) {
          if (this.characterLimitCheck === true) {
            this.characterLimitCheck = false
          }
        }
      },
      submit() {
        this.setActive(false)
        this.$emit('onInput', this.inputText)
      },
      updateValue(input) {
        let value = urlReplace(input, misc.LINK_STYLE)
        if (this.$refs.input.innerHTML !== value) {
          this.$refs.input.innerHTML = contentEditableUtil.replaceNewLine(value)
          contentEditableUtil.moveCursor(document.getElementById('input'))
        }
      },
      handleMount() {
        this.inputText = this.value
        this.updateValue(this.value)
        this.$refs.input.blur()
      }
    },
    watch: {
      value(input) {
        this.updateValue(input)
      }
    },
    mounted() {
      this.handleMount()
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/colours';
  @import '../../../styles/breakpoints';

  .input {
    .limit-container {
      .inner {
        font-size: 16px;
        color: white;
        padding: 6px 0 4px 20px;
        text-transform: uppercase;
      }

      height: 28px;
      width: 498px;
      background-color: #aeaeae;
    }

    &:hover, &:focus {
      .limit-container {
        border: 2px solid #aeaeae;
        box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      }

      .description-input {
        border: 2px solid $light-blue;
        box-shadow: 3px 0 8px 0 rgba(0, 0, 0, 0.24);
      }

      .uk-form-danger {
        border: 2px solid $light-blue !important;
        box-shadow: 3px 0 8px 0 rgba(0, 0, 0, 0.24);
      }
    }
  }

  .container {
    padding-bottom: 20px;
  }

  p {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .uk-form-danger {
    color: $input-warning;
    border: 1px solid $input-warning !important;
  }

  .active {
    background-color: $app-background;
  }

  .description-input {
    width: 470px;
    resize: none;
    overflow-y: scroll;
    border-radius: 1px;
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    background-color: white;
    font-size: 18px;
    color: $share-input-text !important;
    height: 133px;
    padding: 15px 15px 0 13px;

    a {
      border: 2px solid $light-blue !important;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    }
  }

  [contentEditable=true]:empty:before {
    content: attr(data-text);
    font-style: italic;
    font-size: 16px;
    color: $slate;
  }

  [contenteditable]:focus {
    outline: 0 solid transparent;
  }

  @media screen and (max-width: $breakpoint-xlarge) {
    .description-input {
      width: 420px;
    }
    .input {
      .limit-container {
        width: 448px;
      }
    }
  }

</style>
